import { useState } from "react";

// Components
import DashboardTabs from "@/Dashboard/components//DashboardTabs";
import UnreadNotification from "./UnreadNotification";
import { Box } from "@mui/material";
import CustomizedSwitches from "@/Layouts/components/InputComponents/CustomizedSwitches";

// Hooks
import { useScrollToTop } from "@/Common/hooks/Notifications/useScrollToTop";
import { ListRefContext } from "@/Common/context/notifications/ListRefContext";
import { ARCHIVE_TAB, INBOX_TAB } from "@/Constants/notificationsWidgetTabNames";
import { NotificationList } from "./Notifications/NotificationList";
import { useUnreadCount } from "@/Common/hooks/Notifications/useUnreadCount";

export default function NotificationsWidget() {
	const { scrollToTopByTabName, scrollToTop, refs } = useScrollToTop();
	const { unreadCount, setCurrentTab } = useUnreadCount();
	const [unreadOnly, setUnreadOnly] = useState(false);

	return (
		<ListRefContext.Provider value={refs}>
			<DashboardTabs
				tabsIdentifier={"notifications"}
				tabListClass="[&_.MuiTabs-flexContainer]:gap-[10px]"
				extraHeaderContent={
					<Box className="flex flex-col absolute top-[-43px] right-0 w-[180px] gap-[10px]">
						<CustomizedSwitches
							onChange={setUnreadOnly}
							checked={unreadOnly}
							textUnChecked="Unread Only"
							textChecked="Unread Only"
						/>
						<UnreadNotification
							unreadNotifications={unreadCount > 99 ? "99+" : unreadCount}
							onUnreadNotificationClick={scrollToTop}
						/>
					</Box>
				}
				data={[
					{
						tabLabel: INBOX_TAB,
						tabContent: <NotificationList onlyUnRead={unreadOnly} archived={false}></NotificationList>,
					},
					{
						tabLabel: ARCHIVE_TAB,
						tabContent: <NotificationList onlyUnRead={unreadOnly} archived={true}></NotificationList>,
					},
				]}
				onTabClick={scrollToTopByTabName}
				onChange={setCurrentTab}
			/>
		</ListRefContext.Provider>
	);
}
